<template>
  <b-card>
    <debtor-edit-account
      v-if="loader === false"
      class="mt-2 pt-75"
      :user-data="userData"
      :form-data="formData"
    />
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import { ref/* , onUnmounted */ } from '@vue/composition-api'
import store from '@/store'
import router from '@/router'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import DebtorEditAccount from './DebtorEditAccount.vue'
import debtorStoreModule from '../debtorStoreModule'

export default {
  components: {
    BCard,
    DebtorEditAccount,
  },
  data() {
    return {
      loader: true,
      userData: ref(null),
      formData: ref(null),
      address: {
        road_name: null,
        house_no: null,
        place: null,
        zip_code: null,
        city: null,
        country_id: null,
      },
      clientsObj: [],
    }
  },
  created() {
    // const userData = ref(null)
    const USER_APP_STORE_MODULE_NAME = 'app-debtor'

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, debtorStoreModule)

    store.dispatch('app-debtor/fetchDebtor', { id: router.currentRoute.params.id })
      .then(response => {
        this.userData = response.data.data
        this.userData.address = this.userData.debtor_address
          ? this.userData.debtor_address : this.address

        this.userData.address.house_number = this.userData.address.house_no

        this.formData = { ...response.data }
        this.loader = false
      })
      .catch(error => {
        if (error.response.status === 404) {
          this.userData = undefined
        }
        if (error.response.status === 422) {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Error',
              icon: 'CoffeeIcon',
              variant: 'danger',
              text: error.response.data.message,
            },
          })
          this.$router.push('/debtors/list')
        }
      })
  },
}
</script>

<style>

</style>
